import BaseComponent from '../base-component/base-component'
import { Nullable } from '../../types/common'

class ShareComponent extends BaseComponent {
  button: Nullable<HTMLElement>

  constructor() {
    super()

    this.button = this.querySelector('[data-share-button]')
  }

  connectedCallback(): void {
    if (this.button) {
      this.button.addEventListener('click', this.handleButtonClick)
    }
  }

  disconnectedCallback(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.handleButtonClick)
    }
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()

    if (navigator.share) {
      navigator.share({ text: this.dataset.valueToCopy })
    }
  }
}

export default ShareComponent
